import enhance from './BarberProductListContainer';
import { SharedProductList } from '../SharedProductList';

const BarberProductList = enhance(SharedProductList);

export default BarberProductList;
